import {createAction} from 'Shared/utilities/actionCreator';

export enum TaxYearsActionType {
  FETCH_TAX_YEARS = 'taxYears/FETCH_TAX_YEARS',
  CHANGE_TAX_YEARS = 'taxYears/CHANGE_TAX_YEARS',
  CHANGE_TAX_YEARS_LOADING = 'taxYears/CHANGE_TAX_YEARS_LOADING',
}

type TaxYearsState = {
  taxYears: string[];
  latestTaxYear: string | null;
  isLoading: boolean;
  isLoaded: boolean;
};

const DEFAULT_STATE: TaxYearsState = {
  taxYears: [],
  latestTaxYear: null,
  isLoading: false,
  isLoaded: false,
};

const getLatestTaxYear = (taxYears: string[]): string | null => {
  const numericYears = taxYears
    .map(year => Number(year))
    .filter(year => Number.isFinite(year));

  if (numericYears.length === 0) {
    return null;
  }

  return Math.max(...numericYears).toString();
};

export const fetchTaxYears = (encryptedIdentifier: string, isNewYork: boolean) => 
  createAction(TaxYearsActionType.FETCH_TAX_YEARS, { encryptedIdentifier, isNewYork });

export const changeTaxYears = (taxYears: string[]) =>
  createAction(TaxYearsActionType.CHANGE_TAX_YEARS, {taxYears});

export const changeTaxYearsLoading = (isLoading: boolean) =>
  createAction(TaxYearsActionType.CHANGE_TAX_YEARS_LOADING, {isLoading});

type TaxYearsAction =
  | ReturnType<typeof fetchTaxYears>
  | ReturnType<typeof changeTaxYears>
  | ReturnType<typeof changeTaxYearsLoading>;

export default (
  state: TaxYearsState = DEFAULT_STATE,
  action: TaxYearsAction
): TaxYearsState => {
  switch (action.type) {
    case TaxYearsActionType.CHANGE_TAX_YEARS:
      return {
        ...state,
        taxYears: action.payload.taxYears,
        latestTaxYear: getLatestTaxYear(action.payload.taxYears),
        isLoaded: true,
        isLoading: false,
      };
    case TaxYearsActionType.CHANGE_TAX_YEARS_LOADING:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    default:
      return state;
  }
};